import { render, staticRenderFns } from "./AdministrationServers.vue?vue&type=template&id=22751c0c&scoped=true&"
import script from "./AdministrationServers.vue?vue&type=script&lang=ts&"
export * from "./AdministrationServers.vue?vue&type=script&lang=ts&"
import style0 from "./AdministrationServers.vue?vue&type=style&index=0&id=22751c0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22751c0c",
  null
  
)

export default component.exports